/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  InCompatibleProductsAlert.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company      : Honeywell Technology Solutions , Hyderabad
 *
 * @Author      : SivaTeja P(H267743)
 *
 * @Date        : Jul 31, 2019
 *
 * @Version     : Version 1.0
 *
 * @desc: This component contains a modal, that will be shown when ever user tries to add in compatible product.
 * scenario-1 : if BMS product is present in cart, user tries to add Apptus products then this modal will be shown
 * scenario-2 : if Apptus product is present in cart, user tries to add BMS products then this modal will be shown
 * @JIRA : ASDS-118
 * 
 * By            : SandeepRaja
 * On            : Dec 09, 2019
 * Description   : ASDS-1956: Regression Feedback
 ******************************************************************************/

import React from 'react';
import { Modal, Button, Icon, Grid} from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import RouteConstants from "../constants/route-constants";
import { withRouter } from 'react-router-dom';

function handleClick(onClose, history){
    onClose();
    history.push(RouteConstants.MY_CART);
}
function InCompatibleProductsAlert(props: any) {
    return (
        <Modal
            closeIcon={true}
            onClose={props.onClose}
            size="large"
            open={props.open}
            className="selectAccountModal"
        >
            <Modal.Header>
                {props.AlertHeader}
            </Modal.Header>
            <Modal.Content>
                <Grid.Row>
                    <Grid.Column width={1}>
                        <Icon root="common" name="badge-warning" size="xlarge" color="red"/>
                    </Grid.Column>
                    <Grid.Column width={11}>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <b>{props.AlertMsg}</b>
                            </Grid.Column>
                        </Grid.Row>
                        <br/><br/>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                {props.AlertDescription}
                            </Grid.Column>
                        </Grid.Row>

                    </Grid.Column>
                </Grid.Row>
            </Modal.Content>
            <Modal.Footer>
                <div>
                    <Button type="secondary" content="cancel" onClick={props.onClose}/>
                    <Button type="primary" size="medium" content="Go to Cart"  
                            onClick={() => {handleClick(props.onClose,props.history)}}/>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default withRouter(InCompatibleProductsAlert);